import { generatePath, Link } from 'react-router-dom';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { SearchInstanceDto, SearchOption } from '@app/components';
import { generateRouteParams } from '@app/utils';
import { Route } from '@app/constants';

const cnBem = createBemBlockBuilder(['instanceDetailsPage']);

export const formatSiblingInstancesList = (
  titles:
    | SearchInstanceDto['succeedingTitles']
    | SearchInstanceDto['precedingTitles'] = []
) => (
  <ul className={cnBem('__externalLinkWrapper')}>
    {titles.map(({ precedingInstanceId, succeedingInstanceId, title }) => {
      const siblingInstanceId = precedingInstanceId ?? succeedingInstanceId;
      const path = siblingInstanceId
        ? generatePath(Route.instanceDetails, {
            id: siblingInstanceId,
          })
        : generateRouteParams({
            pathname: Route.search,
            query: {
              option: SearchOption.title,
              query: title,
            },
          });

      return (
        <li key={siblingInstanceId + title} className={cnBem('__externalLink')}>
          <Link to={path} className="underlinedLink">
            {title}
          </Link>
        </li>
      );
    })}
  </ul>
);
